/* eslint-disable no-undef */
import { service } from '../api/axios';

export const getCourses = () =>
  service.get('/courses').then((response) => response.data.data);

export const getCoursesOverview = () =>
  service.get('/courses/overview').then((response) => response.data.data);

export const getCourse = (id) =>
  service.get(`/courses/${id}`).then((response) => response.data.data);

export const getLesson = (id) =>
  service.get(`/lessons/${id}`).then((response) => response.data.data);

export const createCourse = async (title, description, imageUrl) => {
  const data = new FormData();
  if (imageUrl) {
    data.append('imageUrl', imageUrl);
  }
  data.append('title', title);
  data.append('description', description);

  const response = await service.post('/courses', data);

  return response.data.data;
};

export const createLesson = async (courseId, title, description) => {
  const data = { courseId, title, description };

  const res = await service.post(`/lessons`, data);
  return res.data.data;
};

export const uploadFile = async (file) => {
  const data = new FormData();
  data.append('file', file);
  const res = await service.post(`/lessonItems/file`, data);
  return res.data.data;
};

export const updateLesson = async (lessonId, items) => {
  const res = await service.post(`/lessons/${lessonId}`, items);
  return res.data.data;
};

export const updateCourse = async (fields) => {
  const data = new FormData();
  Object.keys(fields).map((key) => {
    data.append(key, fields[key]);
  });

  const res = await service.put(`/courses`, data);
  return res.data.data;
};

export const deleteCourseService = async (id) => {
  service
    .delete(`/courses/${id}`)
    .then((responseFromAPI) => responseFromAPI.data);
};
